import { Flex } from "@chakra-ui/react";
import CDS from "design-system";
import LinkButton from "components/Button/LinkButton";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  linkTo?: string;
  linkLabel?: string;
}

export default function SectionHeader({ title, subtitle, linkTo, linkLabel = "View all →" }: SectionHeaderProps) {
  return (
    <Flex align="center" justify="space-between" mb="2">
      <Flex align="baseline" gap="2">
        <CDS.Text12 fontWeight="600" color="content.primary">
          {title}
        </CDS.Text12>
        {subtitle && (
          <CDS.Text10 color="content.tertiary">
            {subtitle}
          </CDS.Text10>
        )}
      </Flex>
      {linkTo && (
        <LinkButton
          to={linkTo}
          variant="outline"
          size="xs"
          fontWeight="normal"
          borderColor="gray.200"
          borderRadius="6px"
          color="content.tertiary"
          _hover={{ borderColor: "gray.300", bg: "gray.50" }}
        >
          {linkLabel}
        </LinkButton>
      )}
    </Flex>
  );
}
